import { Injectable } from '@angular/core';
import { RowClickedEvent } from '@ag-grid-community/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { AutoUnsubscribe } from 'projects/cupcake/src/app/core/auto-unsubscribe';
import { OverviewBaseService } from 'projects/cupcake/src/app/core/overview-base.service';
import { UserInfoService } from 'projects/cupcake/src/app/core/user-info.service';
import { LocalizedDatePipe } from '../../../localized-date.pipe';
import { DocumentsXatSvc } from 'projects/cupcake/src/app/xatena-api';
import { switchMap, tap } from 'rxjs/operators';
import { DocumentUploadService } from 'projects/cupcake/src/app/core/document-upload.service';
import { LocalizedCurrencyPipe } from '../../../localized-currency.pipe';

@AutoUnsubscribe()
@Injectable()
export class FormlyDocumentAttachmentsService extends OverviewBaseService {
  documentIds$ = new BehaviorSubject<number[]>([]);

  constructor(
    router: Router,
    userInfoService: UserInfoService,
    translateService: TranslateService,
    localizedDatePipe: LocalizedDatePipe,
    localizedCurrencyPipe: LocalizedCurrencyPipe,
    private documentService: DocumentsXatSvc,
    private documentUploadService: DocumentUploadService
  ) {
    super(
      router,
      userInfoService,
      translateService,
      localizedDatePipe,
      localizedCurrencyPipe
    );
  }

  query(): Observable<any> {
    return this.documentIds$.pipe(
      switchMap(ids => this.documentService.getPublicDocuments(ids))
    );
  }

  rowClicked(event: RowClickedEvent): void {}

  addDocument(file: File): Observable<number> {
    return this.documentUploadService.upload(file, file.name).pipe(
      tap(documentId => {
        let documentIds = this.documentIds$.value;
        if (documentIds == null) documentIds = [];

        documentIds.push(+documentId);
        this.documentIds$.next(documentIds);
      })
    );
  }

  removeDocument(id: number): Observable<any> {
    return this.documentService.removeDocument(id).pipe(
      tap(() => {
        let documentIds = this.documentIds$.value;
        if (documentIds == null) documentIds = [];
        this.documentIds$.next(documentIds.filter(f => f != id));
      })
    );
  }

  getDocument(id: number): Observable<Blob> {
    return this.documentService.getDocument(id);
  }
}
